import alt from '../alt';


class ChatMessageIsReadActions {
    constructor() {
        this.generateActions('getCreateSuccess');
    }
}

export default alt.createActions(ChatMessageIsReadActions);



/** WEBPACK FOOTER **
 ** ./app/src/actions/ChatMessageIsReadActions.js
 **/